var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useEffect, useMemo } from 'react';
import { Form, Input, Modal, Radio, Select, Switch } from 'antd';
import { EVALUATION_KEY_PATTERN } from './rank-condition-utils';
// -----------------------------------------------------------------------------
// TODO(ranking): Auto-evaluation UI (自動判定 — 上級者向け)
// Hidden until RankingLevel.auto_evaluate_enabled is rolled out in production.
//   Label: 自動判定（上級者向け）
//   Help:  通常はオフのまま。将来の自動判定を使う場合のみ設定します。
// Set SHOW_AUTO_EVALUATION_UI = true to restore the switch + master/custom key picker.
// Create payload logic in handleOk (evaluation_key) is kept for the same rollout.
// -----------------------------------------------------------------------------
const SHOW_AUTO_EVALUATION_UI = false;
/**
 * Create-form fields for rank conditions.
 *
 * `use_evaluation_key` is UI-only. When false (default), create payload omits
 * `evaluation_key` → manual-only condition (staff checks on userpage / v2 evaluate).
 *
 * When true, payload includes `evaluation_key` so the row can be matched by
 * `NewRankConditionEvaluator` if the rank's `auto_evaluate_enabled` is turned on.
 * Today all ranks keep auto_evaluate off, so keys are stored for seeds/future use.
 *
 * `evaluation_key` is global unique in DB and cannot be changed after create
 * (edit modal only updates name / description / active).
 */
const DEFAULT_FORM_VALUES = {
    use_evaluation_key: false,
    key_mode: 'master',
    name: '',
    description: '',
    active: true
};
export default function ConditionFormModal({ open, editingCondition, rankingLevelCode, availableKeys, loading = false, onCancel, onSubmit }) {
    const _Form$useForm = Form.useForm(), _Form$useForm2 = _slicedToArray(_Form$useForm, 1), form = _Form$useForm2[0];
    const isCreate = !editingCondition;
    const useEvaluationKey = Form.useWatch('use_evaluation_key', form);
    const keyMode = Form.useWatch('key_mode', form);
    const keyOptions = useMemo(() => availableKeys.map(item => ({
        value: item.key,
        label: item.description
    })), [availableKeys]);
    const hasMasterKeys = availableKeys.length > 0;
    const effectiveKeyMode = keyMode === 'master' && hasMasterKeys ? 'master' : 'custom';
    useEffect(() => {
        if (!open)
            return;
        if (editingCondition) {
            form.setFieldsValue({
                name: editingCondition.name,
                description: editingCondition.description || '',
                active: editingCondition.active
            });
        }
        else {
            form.setFieldsValue(_objectSpread(_objectSpread({}, DEFAULT_FORM_VALUES), {}, {
                key_mode: hasMasterKeys ? 'master' : 'custom'
            }));
        }
    }, [open, editingCondition, form, hasMasterKeys]);
    const handleKeyChange = key => {
        const master = availableKeys.find(item => item.key === key);
        if (!master)
            return;
        form.setFieldsValue({
            name: master.description.slice(0, 255),
            description: master.description
        });
    };
    const handleUseEvaluationKeyChange = checked => {
        // Turning off: drop key so create stays manual-only.
        if (!checked) {
            form.setFieldsValue({
                evaluation_key: undefined
            });
            return;
        }
        // Turning on: show master/custom picker; do not pre-fill key until user chooses.
        form.setFieldsValue({
            key_mode: hasMasterKeys ? 'master' : 'custom',
            evaluation_key: undefined
        });
    };
    const handleOk = () => __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        const values = yield form.validateFields();
        if (isCreate) {
            const payload = {
                name: values.name.trim(),
                description: (_b = (_a = values.description) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : '',
                active: values.active
            };
            if (SHOW_AUTO_EVALUATION_UI && values.use_evaluation_key) {
                // TODO(ranking): active when SHOW_AUTO_EVALUATION_UI — wire to NewRankConditionEvaluator.
                const key = (_c = values.evaluation_key) === null || _c === void 0 ? void 0 : _c.trim();
                if (!key) {
                    form.setFields([{
                            name: 'evaluation_key',
                            errors: ['自動判定キーを入力または選択してください']
                        }]);
                    return;
                }
                payload.evaluation_key = key;
            }
            yield onSubmit(payload, {
                isCreate: true
            });
        }
        else {
            // Edit: evaluation_key is immutable; only display fields change.
            yield onSubmit({
                name: values.name.trim(),
                description: (_e = (_d = values.description) === null || _d === void 0 ? void 0 : _d.trim()) !== null && _e !== void 0 ? _e : '',
                active: values.active
            }, {
                isCreate: false
            });
        }
    });
    const handleClose = () => {
        form.resetFields();
        onCancel();
    };
    return /*#__PURE__*/ React.createElement(Modal, {
        open: open,
        title: isCreate ? `条件作成 — Rank ${rankingLevelCode}` : `条件編集 — Rank ${rankingLevelCode}`,
        onCancel: handleClose,
        onOk: handleOk,
        okText: isCreate ? '作成' : '更新',
        cancelText: "\u30AD\u30E3\u30F3\u30BB\u30EB",
        confirmLoading: loading,
        destroyOnHidden: true,
        width: 720
    }, /*#__PURE__*/ React.createElement(Form, {
        form: form,
        layout: "vertical",
        initialValues: DEFAULT_FORM_VALUES
    }, /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u540D\u524D",
        name: "name",
        rules: [{
                required: true,
                message: '名前を入力してください'
            }, {
                max: 255,
                message: '255文字以内で入力してください'
            }]
    }, /*#__PURE__*/ React.createElement(Input, {
        placeholder: "\u30E6\u30FC\u30B6\u30FC\u753B\u9762\u30FB\u7BA1\u7406\u753B\u9762\u306B\u8868\u793A\u3059\u308B\u77ED\u3044\u540D\u79F0"
    })), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u8AAC\u660E\uFF08\u4EFB\u610F\uFF09",
        name: "description",
        extra: "\u5185\u90E8\u30E1\u30E2\u3084\u88DC\u8DB3\u3002\u7A7A\u6B04\u3067\u3082\u4F5C\u6210\u3067\u304D\u307E\u3059\u3002"
    }, /*#__PURE__*/ React.createElement(Input.TextArea, {
        rows: 3,
        placeholder: "\u8A73\u7D30\u30FB\u904B\u7528\u30E1\u30E2\uFF08\u4EFB\u610F\uFF09"
    })), SHOW_AUTO_EVALUATION_UI && isCreate ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u81EA\u52D5\u5224\u5B9A\uFF08\u4E0A\u7D1A\u8005\u5411\u3051\uFF09",
        name: "use_evaluation_key",
        valuePropName: "checked",
        extra: "\u901A\u5E38\u306F\u30AA\u30D5\u306E\u307E\u307E\u3002\u5C06\u6765\u306E\u81EA\u52D5\u5224\u5B9A\u3092\u4F7F\u3046\u5834\u5408\u306E\u307F\u8A2D\u5B9A\u3057\u307E\u3059\u3002"
    }, /*#__PURE__*/ React.createElement(Switch, {
        checkedChildren: "\u8A2D\u5B9A\u3059\u308B",
        unCheckedChildren: "\u8A2D\u5B9A\u3057\u306A\u3044",
        onChange: handleUseEvaluationKeyChange
    })), useEvaluationKey ? /*#__PURE__*/ React.createElement(React.Fragment, null, hasMasterKeys ? /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30AD\u30FC\u306E\u7A2E\u985E",
        name: "key_mode"
    }, /*#__PURE__*/ React.createElement(Radio.Group, null, /*#__PURE__*/ React.createElement(Radio, {
        value: "master"
    }, "\u30DE\u30B9\u30BF\u30FC\u304B\u3089\u9078\u629E"), /*#__PURE__*/ React.createElement(Radio, {
        value: "custom"
    }, "\u30AB\u30B9\u30BF\u30E0\u5165\u529B"))) : null, effectiveKeyMode === 'master' ? /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30DE\u30B9\u30BF\u30FC\u30AD\u30FC",
        name: "evaluation_key",
        rules: [{
                required: true,
                message: 'キーを選択してください'
            }]
    }, /*#__PURE__*/ React.createElement(Select, {
        placeholder: "\u30AD\u30FC\u3092\u9078\u629E",
        options: keyOptions,
        onChange: handleKeyChange,
        showSearch: true,
        optionFilterProp: "label"
    })) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30AB\u30B9\u30BF\u30E0\u30AD\u30FC",
        name: "evaluation_key",
        extra: "\u5C0F\u6587\u5B57\u30FBsnake_case\uFF08\u30B7\u30B9\u30C6\u30E0\u5185\u90E8\u7528\uFF09",
        rules: [{
                required: true,
                message: 'キーを入力してください'
            }, {
                pattern: EVALUATION_KEY_PATTERN,
                message: '小文字・数字・アンダースコアのみ（先頭は英字）'
            }]
    }, /*#__PURE__*/ React.createElement(Input, {
        placeholder: "custom_condition_key"
    })))) : null) : null, /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30B9\u30C6\u30FC\u30BF\u30B9",
        name: "active",
        valuePropName: "checked"
    }, /*#__PURE__*/ React.createElement(Switch, {
        checkedChildren: "\u6709\u52B9",
        unCheckedChildren: "\u7121\u52B9"
    }))));
}
